import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var Node = function Node(data) {
  _classCallCheck(this, Node);

  this.incoming = new Map();
  this.outgoing = new Map();
  this.data = data;
};
export var Graph = /*#__PURE__*/function () {
  function Graph(_hashFn) {
    _classCallCheck(this, Graph);

    this._hashFn = _hashFn;
    this._nodes = new Map(); // empty
  }

  _createClass(Graph, [{
    key: "roots",
    value: function roots() {
      var ret = [];

      var _iterator = _createForOfIteratorHelper(this._nodes.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var node = _step.value;

          if (node.outgoing.size === 0) {
            ret.push(node);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return ret;
    }
  }, {
    key: "insertEdge",
    value: function insertEdge(from, to) {
      var fromNode = this.lookupOrInsertNode(from);
      var toNode = this.lookupOrInsertNode(to);
      fromNode.outgoing.set(this._hashFn(to), toNode);
      toNode.incoming.set(this._hashFn(from), fromNode);
    }
  }, {
    key: "removeNode",
    value: function removeNode(data) {
      var key = this._hashFn(data);

      this._nodes.delete(key);

      var _iterator2 = _createForOfIteratorHelper(this._nodes.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          node.outgoing.delete(key);
          node.incoming.delete(key);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "lookupOrInsertNode",
    value: function lookupOrInsertNode(data) {
      var key = this._hashFn(data);

      var node = this._nodes.get(key);

      if (!node) {
        node = new Node(data);

        this._nodes.set(key, node);
      }

      return node;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._nodes.size === 0;
    }
  }, {
    key: "toString",
    value: function toString() {
      var data = [];

      var _iterator3 = _createForOfIteratorHelper(this._nodes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _step3$value = _slicedToArray(_step3.value, 2),
              key = _step3$value[0],
              value = _step3$value[1];

          data.push("".concat(key, ", (incoming)[").concat(_toConsumableArray(value.incoming.keys()).join(', '), "], (outgoing)[").concat(_toConsumableArray(value.outgoing.keys()).join(','), "]"));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return data.join('\n');
    }
  }]);

  return Graph;
}();